var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { display: "flex", width: "780px" } }, [
    _c(
      "div",
      { staticClass: "form-column" },
      [
        _c("el-form", { staticClass: "result-form" }, [
          _c("table", { attrs: { cellpadding: "0", cellspacing: "0" } }, [
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("FileHistory.fileName")))
              ]),
              _c("td", { staticStyle: { width: "300px" } }, [
                _c("span", [_vm._v(_vm._s(_vm.details.fileName))])
              ]),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.BusinessNumber")))
              ]),
              _c(
                "td",
                { staticStyle: { width: "300px" } },
                [
                  _c("el-input", {
                    attrs: { no: "customerRefNo" },
                    model: {
                      value: _vm.details.jobNo,
                      callback: function($$v) {
                        _vm.$set(_vm.details, "jobNo", $$v)
                      },
                      expression: "details.jobNo"
                    }
                  })
                ],
                1
              )
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ItemsNBR")))
              ]),
              _c(
                "td",
                [
                  _c("el-input", {
                    attrs: { no: "1" },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("number")
                      }
                    },
                    model: {
                      value: _vm.resultJson.number,
                      callback: function($$v) {
                        _vm.$set(_vm.resultJson, "number", $$v)
                      },
                      expression: "resultJson.number"
                    }
                  })
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.Weight")))
              ]),
              _c(
                "td",
                [
                  _c("el-input", {
                    attrs: { no: "2" },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("number")
                      }
                    },
                    model: {
                      value: _vm.resultJson.weight,
                      callback: function($$v) {
                        _vm.$set(_vm.resultJson, "weight", $$v)
                      },
                      expression: "resultJson.weight"
                    }
                  })
                ],
                1
              )
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("SeaExport.DateOfCustomsDeclaration")))
              ]),
              _c(
                "td",
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      no: "3",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss"
                    },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("customsDate")
                      }
                    },
                    model: {
                      value: _vm.resultJson.customsDate,
                      callback: function($$v) {
                        _vm.$set(_vm.resultJson, "customsDate", $$v)
                      },
                      expression: "resultJson.customsDate"
                    }
                  })
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CustomsDeclarationNo")))
              ]),
              _c(
                "td",
                [
                  _c("el-input", {
                    attrs: { no: "4" },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("customsDeclarationNo")
                      }
                    },
                    model: {
                      value: _vm.resultJson.customsDeclarationNo,
                      callback: function($$v) {
                        _vm.$set(_vm.resultJson, "customsDeclarationNo", $$v)
                      },
                      expression: "resultJson.customsDeclarationNo"
                    }
                  })
                ],
                1
              )
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FOBValue")))
              ]),
              _c(
                "td",
                [
                  _c("el-input", {
                    attrs: { no: "5" },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("freeOnBoard")
                      }
                    },
                    model: {
                      value: _vm.resultJson.freeOnBoard,
                      callback: function($$v) {
                        _vm.$set(_vm.resultJson, "freeOnBoard", $$v)
                      },
                      expression: "resultJson.freeOnBoard"
                    }
                  })
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AmountNumber")))
              ]),
              _c(
                "td",
                [
                  _c("el-input", {
                    attrs: { no: "6" },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("quantity")
                      }
                    },
                    model: {
                      value: _vm.resultJson.quantity,
                      callback: function($$v) {
                        _vm.$set(_vm.resultJson, "quantity", $$v)
                      },
                      expression: "resultJson.quantity"
                    }
                  })
                ],
                1
              )
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ProcessingFee")))
              ]),
              _c(
                "td",
                [
                  _c("el-input", {
                    attrs: { no: "7" },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("processingFee")
                      }
                    },
                    model: {
                      value: _vm.resultJson.processingFee,
                      callback: function($$v) {
                        _vm.$set(_vm.resultJson, "processingFee", $$v)
                      },
                      expression: "resultJson.processingFee"
                    }
                  })
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExchangeRate2")))
              ]),
              _c(
                "td",
                [
                  _c("el-input", {
                    attrs: { no: "8" },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("rate")
                      }
                    },
                    model: {
                      value: _vm.resultJson.rate,
                      callback: function($$v) {
                        _vm.$set(_vm.resultJson, "rate", $$v)
                      },
                      expression: "resultJson.rate"
                    }
                  })
                ],
                1
              )
            ]),
            _c("tr", [
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_InsurancePremium")))
              ]),
              _c(
                "td",
                [
                  _c("el-input", {
                    attrs: { no: "9" },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("insurancePremium")
                      }
                    },
                    model: {
                      value: _vm.resultJson.insurancePremium,
                      callback: function($$v) {
                        _vm.$set(_vm.resultJson, "insurancePremium", $$v)
                      },
                      expression: "resultJson.insurancePremium"
                    }
                  })
                ],
                1
              ),
              _c("td", { staticClass: "header" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SystemFee")))
              ]),
              _c(
                "td",
                [
                  _c("el-input", {
                    attrs: { no: "10" },
                    on: {
                      focus: function($event) {
                        return _vm.handleFocus("systemFee")
                      }
                    },
                    model: {
                      value: _vm.resultJson.systemFee,
                      callback: function($$v) {
                        _vm.$set(_vm.resultJson, "systemFee", $$v)
                      },
                      expression: "resultJson.systemFee"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }